export const TEST_SPACE_PREFIX = '%';
export const SPACE_NAME_MAX_LENGTH = 30;
export const ENVIRONMENT_NAME_MAX_LENGTH = 40;
export const ENVIRONMENT_READY_TIMEOUT = 1000 * 60 * 5; // 5 minutes
export const DEFAULT_SPACE_DELETION_THRESHOLD = 1000 * 60 * 60; // 1 hour
